import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MarkdownService } from './markdown.service';

@Component({
  selector: 'app-markdown',
  templateUrl: './markdown.component.html',
  styleUrls: ['./markdown.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class MarkdownComponent implements OnInit {

  constructor(private markdownService: MarkdownService) { }

  @Input() title: string;
  @Input() isFile: boolean = false;
  @Input() fileSrc: string; // Path to file
  @Input() textContent: string;

  ngOnInit(): void {
  }

  downloadToPDF() {
  }
}
